import _uniq from 'lodash/uniq';

import { FLOW_STEP_PATHS } from '@/constants';

import Partners from '@/containers/Partners';
import PartnershipDetails from '@/containers/PartnershipDetails';
import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';

import { not } from '@/flow/common';
import {
  isEntityTypePartnership,
  isMerchantRegistered,
  hasPartnershipDetails,
} from '@/flow/configs/selectors';

export class PartnershipBlock {
  constructor({ isManagedFlow, back, next, prerequisite = [] }) {
    this.isManagedFlow = isManagedFlow;
    this.back = back;
    this.next = next;
    this.prerequisite = prerequisite;
  }

  static selectors = {
    isEntityTypePartnership,
    isMerchantRegistered,
    hasPartnershipDetails,
  };

  getBackPathForNextStep() {
    return FLOW_STEP_PATHS.PARTNERS_PATH;
  }

  getSelectors() {
    return PartnershipBlock.selectors;
  }

  withGlobalPrerequisites(prerequisite = []) {
    return _uniq([...prerequisite, ...(this.prerequisite || [])]);
  }

  generateFlowConfig() {
    return [
      {
        id: 'partnership-details',
        path: FLOW_STEP_PATHS.PARTNERSHIP_DETAILS_PATH,
        // For US, partnerships the merchants are registered, so we should
        // go with the registered flow
        prerequisite: this.withGlobalPrerequisites([
          not('isMerchantRegistered'),
          'isEntityTypePartnership',
        ]),
        Container: PartnershipDetails,
        back: this.back,
        next: FLOW_STEP_PATHS.PARTNERS_PATH,
        fieldsToFill: [
          {
            fieldName: 'businessDetails',
            requiredWhenPartial: 'operatingAddress',
            fields: {
              'operatingAddress.city': {},
              'operatingAddress.country': {},
              'operatingAddress.postalCode': {},
              'operatingAddress.street': {},
            },
          },
        ],
      },
      {
        id: 'partners',
        path: FLOW_STEP_PATHS.PARTNERS_PATH,
        prerequisite: this.withGlobalPrerequisites(['hasPartnershipDetails']),
        Container: Partners,
        back: FLOW_STEP_PATHS.PARTNERSHIP_DETAILS_PATH,
        next: this.next,
        extraProps: {
          defaultRole: STAKEHOLDER_ROLES_V2.PARTNER,
          availableRoles: [STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER],
          roleConstraints: {
            [STAKEHOLDER_ROLES_V2.PARTNER]: {
              min: 1,
            },
            [STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER]: {
              min: 0,
              max: 3,
            },
          },
        },
        fieldsToFill: [
          {
            fieldName: 'stakeholders',
            roles: [STAKEHOLDER_ROLES_V2.PARTNER],
          },
        ],
      },
    ];
  }
}
